
import * as defaultImport from "@splunk/react-ui/Layout";
export * from "@splunk/react-ui/Layout";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
